<template>
    <div v-if="isButtonStyleTile" :class="{ 'w-full md:w-1/3 lg:w-md lg:max-w-1/3': ! inline, 'w-full': inline && solid && inBasket }">
        <template v-if="inBasket">
            <u-modals-continue-shopping v-if="added" :item="basketItem" basket-url="/basket"></u-modals-continue-shopping>
            <div class="cursor-not-allowed uppercase flex items-center justify-center w-full px-3 md:px-2 py-2 bg-gray-500 rounded" :class="{ 'text-white bg-white-translucent font-bold': solid, 'text-gray-900': ! solid }">
                <span class="text-xs text-center">
                    In basket
                </span>
            </div>
        </template>

        <form v-else class="flex w-full text-center" ref="form" @submit.prevent="add">
            <button type="submit" class="flex items-center justify-center w-full text-white bg-green-500 hover:bg-green-600 p-2" :class="{ 'py-3 rounded-full': ! inline, 'rounded': inline, 'px-3': narrow, 'px-3 md:px-6': ! narrow, 'text-sm': small, 'shadow-lg': shadowed }">
                <template v-if="loading">
                    <span class="fal fa-spinner fa-spin fa-x2"></span>
                </template>

                <template v-else>
                    <span v-if="! noIcon && iconComponent" :is="iconComponent" v-bind="iconProps" class="h-4 mr-3"></span>
                    <span v-if="! noIcon && ! iconComponent" class="fal fa-shopping-basket mr-2"></span>
                    <span class="text-xs text-nowrap" v-text=buttonText></span>
                </template>
            </button>
        </form>
    </div>

    <div v-else class="flex-1">
        <template v-if="inBasket" class="w-full h-full">
            <button class="w-full bg-grey-500 text-white font-semibold py-2 rounded-md hover:bg-grey-600 cursor-not-allowed">
                Already in basket
            </button>
        </template>

        <form v-else ref="form" @submit.prevent="add" class="w-full h-full">
            <button type="submit" class="w-full bg-green-500 text-white font-semibold py-2 rounded-md hover:bg-green-600">
                <template v-if="loading">
                    <span class="fal fa-spinner fa-spin fa-x2"></span>
                </template>

                <template v-else>
                    <span v-if="! noIcon && iconComponent" :is="iconComponent" v-bind="iconProps" class="h-4 mr-3"></span>
                    <span v-if="! noIcon && ! iconComponent" class="fal fa-shopping-basket mr-2"></span>
                    <span v-text=buttonText></span>
                </template>
            </button>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },

        type: {
            type: String,
            required: true,
        },

        parent: {
            type: String,
            required: true,
        },

        skuInBasket: {
            type: Boolean,
            required: true,
        },

        extra: {
            type: Object,
            required: false,
            default() {
                return {};
            },
        },

        icon: {
            type: String,
            required: false,
        },

        noIcon: {
            type: Boolean,
            default: false,
        },

        inline: {
            type: Boolean,
            default: false,
        },

        solid: {
            type: Boolean,
            default: false,
        },

        narrow: {
            type: Boolean,
            default: false,
        },

        shadowed: {
            type: Boolean,
            default: false,
        },

        small: {
            type: Boolean,
            default: false,
        },

        // To distinguish between:
        // - The buttons on the Brick Library tiles
        // - The buttons on the Brick product show page
        buttonStyleType: {
            type: String,
            required: false,
            default: 'tile'
        },

        buttonText: {
            type: String,
            required: false,
            default: 'Order sample'
        },
    },

    data() {
        return {
            added: false,
            basketItem: null,
            loading: false,
        };
    },

    created() {
        Orbit.$on('global::basket:mount', this.check);
        Orbit.$on('global::basket:update', this.check);

        if (this.basketItem) {
            return;
        }

        this.check();
    },

    computed: {
        csrfToken() {
            return window.axios.defaults.headers.common['X-CSRF-TOKEN'];
        },

        iconComponent() {
            return null;
        },

        iconProps() {
            return {};
        },

        // If the SKU is already in the basket list from the browser page load.
        // Or if the basketItem has been updated via the current Vue instance.
        inBasket() {
            return this.skuInBasket || this.added || (null !== this.basketItem && undefined !== this.basketItem);
        },

        isButtonStyleTile() {
            return this.buttonStyleType === 'tile';
        },
    },

    methods: {
        check() {
            if (this.added || this.inBasket) {
                return;
            }

            this.basketItem = Orbit.basket ? Orbit.basket.get(this.parent) : null;
        },

        add() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            axios.post('/api/basket', {
                _token: this.csrfToken,
                _method: 'PUT',
                type: this.type,
                parent: this.parent,
                extra: this.extra,

            }).then(({ data }) => {
                this.basketItem = data.newest;
                this.added = true;
                Orbit.$emit('global::basket:update', data);

            }).catch((data) => {
                if(data?.response?.data?.error_type === 'already_in_basket') {
                    this.added = true;
                }
                this.loading = false;
                this.check();
            });
        },
    },
};
</script>
